module.exports = __webpack_public_path__ + "08cd44297e1b24f0a26e7168e6a13cf9.png";